<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="40%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="类型:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="typeCode">
                        <span v-if="viewFlag === 'view'">{{dataForm.typeCode}}</span>
                        <el-input v-else v-model="dataForm.typeCode" placeholder="类型" size="small" maxlength="10"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="名称:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="typeName">
                        <span v-if="viewFlag === 'view'">{{dataForm.typeName}}</span>
                        <el-input v-else v-model="dataForm.typeName" placeholder="名称（如：标准采购订单-量产）" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="简化名称:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="shortName">
                        <span v-if="viewFlag === 'view'">{{dataForm.shortName}}</span>
                        <el-input v-else v-model="dataForm.shortName" placeholder="简化名称（如：量产订单）" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align:right;">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()">
                    保存
                </el-button>
                <!-- <el-button v-if="viewFlag !== 'view'" size="small" type="success" @click="dataFormPublish()">
                    发布
                </el-button> -->
            </el-col>
        </el-row>
    </el-form>
</el-dialog>
</template>

<script>
import {
    editPurchaseType,
    createPurchaseType,
    getPurchaseTypeById,
} from '@/controller/systemData'
export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            disabled_flag: true,
            viewFlag: '',
            dataForm: {
                typeCode: '',
                typeName: '',
                shortName: ''
            },
        }
    },
    mounted() {},
    methods: {
        init(data, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getPurchaseTypeById({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                            console.log(data.body)
                            this.dataForm = data.body;
                        }
                    });
                }
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    // debugger
                    if (this.dataForm.id) {
                        editPurchaseType(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createPurchaseType(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body ? data.body.id : '';
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        getStyle() {
            return 'width: 100px; text-align: right'
        },
        getStyle2() {
            return 'width: 455.5px;'
        }
    },
}
</script>
